import classnames from 'classnames';
import { useBlockProps, InnerBlocks } from '@wordpress/block-editor';

export default function save( { attributes } ) {
	const {
		borderRadius,
		boxShadow,
		animation,
		align,
		id,
		uuid,
		disableScroll,
		className,
		minWidth,
	} = attributes;

	const modalStyle = {
		width:
			-1 !== className?.indexOf( 'is-style-top-bar' ) ||
			-1 !== className?.indexOf( 'is-style-bottom-bar' )
				? minWidth
				: undefined,
	};

	const popperClass = classnames(
		'wp-block-popper',
		boxShadow,
		borderRadius,
		className,
		{
			'wp-block-popper__animate': !! animation,
			'no-scroll': disableScroll,
		}
	);

	if (
		animation &&
		! className?.includes( 'is-style-off-canvas' ) &&
		! className?.includes( 'is-style-off-canvas-left' )
	) {
		modalStyle[ '--popper-animation' ] = animation;
	}

	return (
		<dialog
			{ ...useBlockProps.save( {
				className: popperClass,
				style: modalStyle,
			} ) }
			data-id={ uuid }
			data-modal={ 'center center' === align || undefined }
			data-align={ align }
			id={ id }
		>
			<InnerBlocks.Content />
		</dialog>
	);
}
